import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { statusMock, tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import StatusVisit from "../../components/StatusVisit";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ManageCourseFeatures() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState("");
  const { data, isPending, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/course-attribute/",
  );
  const removeCategory = $api.useMutation(
    "delete",
    "/site-api/v1/course-attribute/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ویژگی های دوره");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteCourseAttributeItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "نام کاربر",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/add-course-feature",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/add-course-feature",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={removeCategory.isPending}
        title="حذف از ویژگی ها ؟"
        description="حذف این ویژگی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          removeCategory.mutate(
            {
              params: {
                query: {
                  course_attribute_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                setIsOpen(false);
                notify.success(data.message);
                setId("");
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/add-course-feature"} className="button-style">
          ایجاد ویژگی
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteCourseAttributeItem"]>
            columns={columns}
            dataSource={data?.data}
            loading={isPending}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
